import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

export default function EmptyState({ 
  title,
  description,
  icon: Icon, 
  action,
  className 
}) {
  const { t } = useTranslation();
  return (
    <div className={cn(
      "text-center py-20 bg-muted/5 rounded-[2rem] border-2 border-dashed border-border shadow-inner flex flex-col items-center justify-center transition-all hover:bg-muted/10",
      className
    )}>
      <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mb-6 shadow-sm border border-border/50">
        {Icon ? <Icon className="w-10 h-10 text-muted-foreground opacity-50" /> : <div className="w-10 h-10 rounded-xl bg-muted-foreground/10" />}
      </div>
      <h3 className="text-xl font-black tracking-tight text-foreground mb-2">
        {title || t('emptyState.noRecordsTitle')}
      </h3>
      <p className="text-sm font-medium text-muted-foreground max-w-sm mb-6 leading-relaxed">
        {description || t('emptyState.noRecordsDescription')}
      </p>
      {action && (
        <div className="flex items-center gap-1 font-bold text-sm text-primary hover:underline transition-all active:scale-95 cursor-pointer">
          {action}
        </div>
      )}
    </div>
  );
}
